import lottie from 'lottie-web'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/all'

gsap.registerPlugin(ScrollTrigger)

export function lottiePlayer(element: Element): void {
  const background = element as HTMLDivElement
  const lottiePath = background.dataset.lottie
  let mm = gsap.matchMedia()
  // get parent section
  const section = background.closest('section')

  lottie.setQuality(3)

  let animation = lottie.loadAnimation({
    container: background,
    renderer: 'canvas',
    path: lottiePath,
    autoplay: true,
    loop: true,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid meet'
    }
  })

  // Check if the window and document objects are available
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    // console.log('wiundow and document are available')
    ScrollTrigger.create({
      trigger: section,
      onEnter: () => {
        animation.play()
      },
      onLeave: () => {
        animation.pause()
      },
      onEnterBack: () => {
        animation.play()
      },
      onLeaveBack: () => {
        animation.pause()
      }
    })
  }
}
